// extracted by mini-css-extract-plugin
module.exports = {"Button":"Settings_Button__saQhX"};